function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue-line-clamp"] = t() : e["vue-line-clamp"] = t();
}(window, function () {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == _typeof(e) && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 0);
  }([function (e, t, n) {
    "use strict";

    n.r(t);

    function r(e, t, n) {
      if (n) {
        var r = parseInt(t.arg);
        isNaN(r) && (console.warn("line-height argument for vue-line-clamp must be a number (of pixels), falling back to 16px"), r = 16);
        var o = r * n;
        e.style.maxHeight = o ? o + "px" : "", e.style.overflowX = "hidden", e.style.lineHeight = r + "px";
      } else e.style.maxHeight = e.style.overflowX = "";
    }

    var o = function o(e, t, n) {
      var r = parseInt(t.value);
      isNaN(r) ? console.error("Parameter for vue-line-clamp must be a number") : r !== e.vLineClampValue && (e.vLineClampValue = r, n ? n(e, t, r) : e.style.webkitLineClamp = r || "");
    },
        i = {
      install: function install(e, t) {
        t = Object.assign({
          importCss: !1,
          textOverflow: "ellipsis"
        }, t);
        var n = "\n      display: block;\n      display: -webkit-box;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      word-break: break-all;\n      text-overflow: ".concat(t.textOverflow, ";\n    ");

        if (t.importCss) {
          var i = window.document.styleSheets,
              l = ".vue-line-clamp{".concat(n, "}");
          if (i && i[0] && i.insertRule) i.insertRule(l);else {
            var a = window.document.createElement("style");
            a.id = "vue-line-clamp", a.appendChild(window.document.createTextNode(l)), window.document.head.appendChild(a);
          }
        }

        var u = "webkitLineClamp" in document.body.style ? void 0 : t.fallbackFunc || r;
        e.directive("line-clamp", {
          currentValue: 0,
          bind: function bind(e) {
            t.importCss ? e.classList.add("vue-line-clamp") : e.style.cssText += n;
          },
          inserted: function inserted(e, t) {
            return o(e, t, u);
          },
          updated: function updated(e, t) {
            return o(e, t, u);
          },
          componentUpdated: function componentUpdated(e, t) {
            return o(e, t, u);
          }
        });
      }
    };

    t["default"] = i;
  }])["default"];
});